import { useEffect, useState } from "react";
import CreateTemplateWrapper from "./createTemplateWrapper";

export default function View() {
    return (
        <CreateTemplateWrapper />
    )
}